
document.addEventListener("DOMContentLoaded", function() {
    initOpenSideHeader();
    initCloseSideHeader();
    initOpenSideHeaderDropdown();
});
window.addEventListener("Pageeditor:insert", function() {
    initOpenSideHeader();
    initCloseSideHeader();
    initOpenSideHeaderDropdown();
});
window.addEventListener("Pageeditor:change", function() {
    initOpenSideHeader();
    initCloseSideHeader();
    initOpenSideHeaderDropdown();
});

function initOpenSideHeader(){
    var btn = document.getElementById("sideHeaderOpener");
    var container = document.getElementById("sideHeaderContainer");
    if(btn != null){
        btn.addEventListener("click", function() {
            container.classList.add("open");
            document.body.classList.add("overflow-hidden");
        });
    }
}
function initCloseSideHeader(){
    var btn = document.getElementById("sideHeaderCloser");
    var container = document.getElementById("sideHeaderContainer");
    if(btn != null) {
        btn.addEventListener("click", function () {
            container.classList.remove("open");
            document.body.classList.remove("overflow-hidden");
        });
    }
}
function initOpenSideHeaderDropdown(){
    var trigger = document.getElementById("sideHeader__dropdown");
    if(trigger != null){
        trigger.addEventListener("click", function() {
            if (trigger.classList.contains('open')) {
                trigger.classList.remove("open");
            }else{
                trigger.classList.add("open");
            }
        });
    }
}
function setActionLink(link, title)
{
    var btn = document.getElementById("sideHeaderActionLink");
    var selected = document.getElementById("sideHeaderActionLabel")
    console.log(title)
    if (btn != null)
    {
        selected.innerText=title;
        btn.href = link;
    }

    let element = document.getElementById('sideHeader__dropdown');
    element.classList.add('pointer-none');

    self.timeoutHandle = setTimeout (
        function () {
            element.classList.remove('pointer-none');
            //element.classList.remove('open');
        }
        , 1000);
}
window.setActionLink = setActionLink
